import { useEffect, useState, useCallback } from 'react';

const KEY = 'ouistupastu_demo_lang';

export const useDemoLang = () => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem(KEY) || 'fr'; } catch { return 'fr'; }
  });
  useEffect(() => { try { localStorage.setItem(KEY, lang); } catch {} }, [lang]);
  const t = useCallback((fr, en) => (lang === 'fr' ? fr : en), [lang]);
  return { lang, setLang, t };
};

// Web Speech API helper — safe no-op when unsupported.
export const speak = (text, lang = 'en-US') => {
  try {
    if (typeof window === 'undefined' || !window.speechSynthesis) return false;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = lang;
    u.rate = 0.95;
    u.pitch = 1.0;
    window.speechSynthesis.speak(u);
    return true;
  } catch { return false; }
};
export const stopSpeak = () => { try { window.speechSynthesis?.cancel(); } catch {} };
